export default __webpack_public_path__ + "static/media/graphic-guards-protector.83bad86f.mp4";